export const ACCIDENT_INFO_FIELDS = [
  'accidentDate',
  'contract',
  'damageAmount',
  'currency',
  'accidentInformation',
  'formLanguage',
];
